import axiosInstance from 'ns_libs/nsAxios';
import { useMutation } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import { InvestmentMemoFormData } from 'views/InvestmentMemo/types';

interface GenerateInvestmentMemoDeckRequest {
    organizationId: string;
    dealId: number;
    proFormaId: number;
    exportAs: 'pdf' | 'pptx';
    formData: InvestmentMemoFormData;
}

export interface GenerateInvestmentMemoDeckResponse {
    taskId: string;
}

const generateInvestmentMemoDeck = async ({
    organizationId,
    dealId,
    proFormaId,
    exportAs,
    formData,
}: GenerateInvestmentMemoDeckRequest): Promise<GenerateInvestmentMemoDeckResponse> => {
    const endpoint = `${API_ENDPOINTS.INVESTMENT_MEMO.GENERATE_DECK(dealId, proFormaId)}?organizationId=${organizationId}`;
    const response = await axiosInstance.post(endpoint, { exportAs, formData });
    return response.data;
};

const useGenerateInvestmentMemoDeck = () => useMutation({ mutationFn: generateInvestmentMemoDeck });

export default useGenerateInvestmentMemoDeck;
